export default {
  action: 'Action',
  actionBlockedDueToDuplicateUuid:
    'Action blocked due to duplicate device UUID',
  active: 'Active',
  add: 'Add',
  addAnotherIp: 'Add Another IP',
  addDeviceHeaderwoSuite: 'Add Devices: {{screen}}',
  addDevices: 'Add Device',
  addIp: 'Add IP',
  addIPAddress: 'Add IP Address',
  addIpHeader: 'Add IP Address: {{screen}}',
  addRole: 'Add Role',
  addSuite: 'Add Suite',
  addSuiteHeader: 'Add Suite: {{screen}} - Suite {{suite}}',
  adminRoleWillHaveFullAccess: 'Admin Role will have full access',
  all: 'All',
  and: 'and',
  applianceStatus: 'Appliance Status',
  apply: 'Apply',
  assignedToDevice: 'Assigned to device',
  availableDevices: 'Available Devices',
  bookingDate: 'Booking Date',
  bookingRef: 'Booking Ref',
  bulkEditScreenIPs: 'Bulk Edit Screen IPs',
  bulkHeadingMsg:
    'Changes made to IPs here will be reflected across all associated screen devices.',
  cancel: 'Cancel',
  ccEmails: 'CC Emails',
  certificateAutoSync: 'Certificate Auto Sync',
  certificateExpired: 'Certificate Expired',
  certificateForAllDevicesMustBeValid:
    'Certificate for all devices must be valid',
  certificateNotAvailable:
    'Device certificate unavailable for this serial number.',
  certificateNotValid: 'Certificate Not Valid',
  chain: 'CHAIN',
  chainSmall: 'Chain',
  changesSavedSuccessfully: 'Changes saved successfully',
  clear: 'Clear',
  clearAll: 'Clear All',
  clearAllSmall: 'Clear all',
  clearSelection: 'Clear Selection',
  collapseAll: 'Collapse All',
  common: {
    confirm: 'Confirm',
  },
  composition: 'Composition',
  compositionCount_one: 'Composition (1)',
  compositionCount_other: 'Composition{{plural}} ({{count}})',
  compositionDetails: 'Composition Details',
  compositionName: 'Composition Name',
  confirmDelete: 'Confirm Delete',
  confirmDeleteIP: 'Are you sure you want to delete the IP Address {{ip}}?',
  confirmDeleteIPAssigned:
    'This IP is currently assigned and will disconnect from the device: {{deviceInfo}} at {{location}}.',
  confirmDeleteSuite:
    'Are you sure you want to delete {{screen_name}} - Suite {{suite_number}}? Please choose an appropriate option to proceed.',
  content: 'Content',
  contentDetails: 'Content Details',
  copyLink: 'Copy Link',
  countTheatres_one: '1 Theatre',
  countTheatres_other: '{{count}} Theatres',
  cplMarkers: 'CPL Markers',
  create: 'Create',
  createdOn: 'Created On',
  creditOffset: 'Credit Offset',
  creditsOffset: 'Credits Offset',
  dcpStatusTitle: 'DCP Status',
  deactivatedUser: 'Deactivated User',
  delete: 'Delete',
  deleteIp: 'Delete IP',
  deleteSuite: 'Delete Suite',
  deleteTheatreGroup: 'Delete Theatre Group',
  deleteTheatreGroupConfirmation:
    "Are you sure you want to delete {{groupName}}? This action is permanent and can't be undone.",
  deleteTheatreWarningMessage:
    'Deleting it will affect their access, Are you sure you want to proceed?',
  details: 'Details',
  deviceWillBeRemoved: 'Device will be removed from this suite',
  deviceModel: 'Device Model',
  deviceRole: 'Device Role',
  devices: 'Devices',
  deviceWillBeMoved:
    'Device will be moved to Screen {{destination}} Devices after saving',
  deviceWillBeMovedToStandby: 'Device will be moved to Standby',
  disabled: 'Disabled',
  doNotIncludePrDevices: 'DO NOT include PR devices for KDM generation.',
  downloadAttempt: 'Download Attempt',
  downloadDetails: 'Download Details',
  downloadHistory: 'Download History',
  downloadKDMs: 'Download KDMs',
  downloadLocation: 'Download Location',
  downloadNow: 'Download Now',
  downloadProgress: '{{progress}} Completed',
  downloadSize: 'Download Size',
  downloadStatus: 'Download Status',
  duplicateDeviceFound: 'Duplicate Device Found',
  duplicateDeviceWarning: 'Duplicate device found in {{screens_and_suites}}',
  editDevice: 'Edit Device',
  editDeviceMeta: 'Edit Device Metadata',
  editIp: 'Edit IP',
  editIpHeader: 'Edit IP - Screen {{screen}}',
  editRoles: 'Edit Roles',
  editSuite: 'Edit Suite',
  editSuiteHeader: 'Edit Suite: {{screen}} - Suite {{suite}}',
  editTheatreGroup: 'Edit Theatre Group',
  effectiveFrom: 'Effective From',
  email: 'Email',
  emailKDMS: 'Email KDMs',
  emptyScreen: 'No suite added to the screen',
  emptyStandby: 'No devices in standby',
  enabled: 'Enabled',
  enterEmail: 'Enter email',
  enterGateway: 'Enter Gateway',
  enterIpAddress: 'Enter IP Address',
  enterSoftwareVersion: 'Enter Software Version',
  enterSubnetMask: 'Enter Subnet Mask',
  errorDownloadingKDMs: 'Error in KDM download',
  errorFetching: 'Error while fetching data',
  errorFetchingDevices: 'Error while fetching devices',
  errorFetchingFilterSettings: 'Error while fetching filter settings',
  errorFetchingGroups: 'Error in loading groups list',
  errorFetchingUser: 'Error in loading user information',
  errorFetchingUsersList: 'Error in loading users list',
  errorFetchingWireTapCount: 'Error in loading total no of WireTAPs',
  errorLoadingWireTap: 'Error in loading WireTAPs',
  errorMessage: 'An error occurred while processing your request',
  errorReportDownload: 'Error downloading {{report}} report: {{error}}',
  errors: {
    fetchDeviceModels: 'Error in fetching device models',
    fetchDeviceRoles: 'Error in fetching device roles',
    fetchTheatreInfo: 'Error in fetching theatre information',
  },
  errorUploadingCertificate: 'Error uploading certificate',
  expandAll: 'Expand All',
  expired: 'Expired',
  expiredOn: 'Expired On',
  expiring: 'Expiring (in {{days}} days)',
  expiring_1: 'Expiring',
  expiryOn: 'Expiry On',
  failedToDeleteTheatreGroup: 'Failed to delete theatre group',
  failedToDeleteTheatreGroupMessage:
    'An error occurred while deleting the theatre group',
  failedToRemoveUser: 'Failed to remove user',
  failedToSendUserInvite: 'Failed to send user invite',
  failedToUpdateUser: 'Failed to update user',
  fetchCompositions: 'Error in loading compositions',
  fetchingRoles: 'Fetching Roles...',
  fetchTheatres: 'Error in loading theatres',
  filter: 'Filter',
  filterBy: 'Filter By',
  filterByTheatres: 'Filter by Theatres',
  filterPanelCompositionType: 'COMPOSITION TYPE',
  filterPanelCompositionTypeOptions_advertisement: 'Advertisement',
  filterPanelCompositionTypeOptions_feature: 'Feature/Features',
  filterPanelCompositionTypeOptions_others: 'Others',
  filterPanelCompositionTypeOptions_psaPolicy: 'PSA/Policy',
  filterPanelCompositionTypeOptions_trailerTeaserPromo: 'Trailer/Teaser/Promo',
  filterPanelDcpDownloadStatus: 'DCP DOWNLOAD STATUS',
  filterPanelDcpIngestStatus: 'DCP INGEST STATUS',
  filterPanelKdmIngestStatus: 'KDM INGEST STATUS',
  filterPanelKdmStatus: 'KDM DELIVERY STATUS',
  filterPanelKdmValidity: 'KDM VALIDITY',
  filterPanelTheatresPlaceHolder: 'Search for Theatres',
  filterPanelTheatresTitle: 'THEATRES',
  filters: 'Filters',
  from_time_of_booking: 'from the time of booking.',
  fullAccess: 'Full Access',
  future: 'Valid in Future',
  gateway: 'Gateway',
  generateReport: 'Generate Report',
  groupCount_one: '{{count}} Group',
  groupCount_other: '{{count}} Groups',
  groupName: 'Group Name',
  groupsCreateGroupCancel: 'Cancel',
  groupsCreateGroupCreateTheatreGroups: 'Create Theatre Groups',
  groupsCreateGroupGroupCreated: 'Group created',
  groupsCreateGroupGroupName: 'Group Name',
  groupsCreateGroupGroupPlaceHolderName: 'Enter Group Name',
  groupsCreateGroupHeaderTitle: 'Create Group',
  groupsCreateGroupSaveChanges: 'Save Changes',
  groupsCreateGroupTheatreSelection: 'Theatre Selection',
  groupsHeaderCreateTheatreGroupButton: 'Create Theatre Group',
  groupsHeaderViewLogsButton: 'View Logs',
  groupUpdated: 'Group Updated',
  holdoverKdmRequests: 'Holdover KDM Requests',
  hour: 'Hour',
  iabScreens: 'IAB Screens',
  inbox: 'Inbox',
  invalidEmail: 'Invalid email address',
  ipRequired: 'IP address is required',
  ipAddress: 'IP Address',
  ipAddress_1: 'IP ADDRESS',
  ipAlreadySelectedInForm:
    'This IP is already selected/assigned. Please select another IP.',
  ipCount_one: 'IPs (1)',
  ipCount_other: 'IPs ({{count}})',
  kdmDetails: 'KDM Details',
  kdmValidityTheatreTimeZone: 'KDM Validity (Theatre Time Zone)',
  lastUpdatedBy: 'Last Updated By',
  lastUpdatedOn: 'Last Updated On',
  linkExpiredOnDownload:
    'Download cannot be started. The delivery link is either expired or no longer eligible for download.',
  linkReceivedOn: 'Link Received On',
  loading: 'Loading',
  location: 'Location',
  logsTheatreGroups: 'Logs: Theatre Groups',
  minute: 'Minute',
  moveModalText: 'Device {{name}} will be moved to standby, proceed?',
  moveTo: 'Move to',
  moveToScreen: 'Screen {{number}}',
  moveToStandby: 'Move to Standby',
  moveToStandbyDevices: 'Move to Standby Devices',
  moveToUnmapped: 'Move to Screen {{number}} Devices',
  movie: 'Movie',
  movieName: 'Movie Name',
  multiThumbprintKdm: 'Multi Thumbprint KDM Screens with DC2 (DCP 2000) server',
  multiThumbprintKdmOtherServices:
    'Multi Thumbprint KDM Screens with other servers',
  name: 'Name',
  needs_1_SM_RMB_msg:
    'Every suite must contain exactly 1 SM/1 RMB. Please add SM/RMB device with certificate to proceed',
  newData: 'New Data',
  newRequestCreated:
    'New requests has been created with Request ID {{requestId}}.',
  no_compositions: 'No Compositions',
  no_theatres: 'No Theatres available',
  noAccess: 'No Access',
  noBookings: 'No bookings available',
  noData: 'No Data',
  noExpiredBookings: 'No expired WireLink downloads found.',
  noIpFound: 'No IPs Available',
  noMatchFound: 'No match found',
  noResultsFound: 'No Results Found',
  normalKdm: 'Normal KDM',
  notDownloaded: 'Not Downloaded',
  notSelected: 'Not Selected',
  noWiretapAvailable: 'No WireTAPs Available',
  oldData: 'Old Data',
  optional: 'Optional',
  osVersion: 'OS VERSION',
  pending: 'Pending',
  readyToDownload: 'Ready to Download',
  receivedOn: 'Received On',
  recipientDetails: 'Recipient Details',
  recipientEmails: 'Recipient Emails',
  remove: 'Remove',
  removeFromTheatre: 'Remove from Theatre',
  removeModalText: 'Are you sure you want to remove {{name}} from the theatre?',
  removeUser: 'Remove User',
  removeUserConfirmation:
    "Removing this user will remove their access from this company. The user can't log in or perform any actions.",
  reportInitiated: '{{report}} is initiated.',
  reportReady: '{{report}} is ready.',
  reportsheaderTitle: 'Reports',
  requestedBy: 'Requested By',
  requestedKdmValidity: 'Requested KDM Validity',
  requestedOn: 'Requested On',
  requestFailed: 'Request Failed',
  requestFailedMessage: 'Failed to send the request. Please try again.',
  requestSent: 'Request Sent',
  role: 'Role',
  roles: 'Roles',
  save: 'Save',
  saveChanges: 'Save Changes',
  screen: 'Screen',
  screenInactive: 'Inactive',
  screens: 'Screens',
  searchByLocation: 'Search by Location',
  searchByNameOrEmail: 'Search by Name or Email',
  searchBySerialNo: 'Search by Serial Number',
  searchByTheatreGroup: 'Search by Theatre Group',
  searchByTheatreGroupName: 'Search by Theatre Group Name',
  searchByTheatreName: 'Search by Theatre Name',
  searchCompositions: 'Search by Composition Name',
  searchCompositionsPlaceholder: 'Search for Compositions',
  searchDeviceModel: 'Search Device Model',
  searchForChain: 'Search for Chain',
  searchForLocation: 'Search for Location',
  searchForOsVersion: 'Search for OS Version',
  searchForPublicIp: 'Search for Public IP',
  searchForSerialNumber: 'Search for Serial Number',
  searchForTheatre: 'Search for Theatre',
  searchForWiretap: 'Search For WireTAP',
  searchMovies: 'Search by Movie Name',
  searchPlaceholder: 'Search for theatres you manage',
  searchSerialNumber: 'Search Serial Number',
  searchTheatres: 'Search by Theatre Name',
  selectIpAddress: 'Select IP Address',
  selectRole: 'Select Role',
  sendInvite: 'Send Invite',
  serialNumber: 'Serial Number',
  serialNumber_1: 'SERIAL NUMBER',
  show: 'Show',
  showingCountResults_one: 'Showing 1 result for',
  showingCountResults_other: 'Showing {{count}} results for',
  showingResults: 'Showing {{start}}-{{end}} of {{total}} items',
  showingResultsFor: 'Showing results for',
  showMore: 'Show More',
  softwareVersion: 'Software Version',
  somethingWentWrong: 'Something went wrong',
  standby: 'Standby',
  standbyDevices: 'Standby Devices',
  standbyHeader_one: 'Standby Devices (1)',
  standbyHeader_other: 'Standby Devices ({{count}})',
  status: 'Status',
  subnetMask: 'Subnet Mask',
  suite: 'Suite',
  suiteCreationRules: 'Suite Creation Rules',
  suiteDevicesExpiredMsg: 'Suite has devices with expired certificates',
  suiteEffectiveFrom: 'Suite Effective From',
  suiteInvalid: 'Suite invalid for KDM generation',
  suiteLogs: 'Suite Logs',
  suiteMustContain:
    'Suite must contain exactly {{smCount}} SM or {{rmbCount}} RMB device.',
  suiteMustContainAdLd:
    'Suite must contain at least 1 additional device with Device Role as LD',
  suiteMustContainLDorPR:
    'Suite must contain at least 1 additional device with Device Role as LD or PR.',
  suiteMustContainSm: 'Suite must contain exactly {{smCount}} SM device.',
  suiteMustContainSMOBE:
    'Suite must contain exactly 1 SM / OBAE with SM device.',
  suiteNo: 'Suite {{number}}',
  theatre: 'Theatre',
  theatre_1: 'THEATRE',
  theatre_header: 'Theatre',
  theatreCount: 'Theatre Count',
  theatreGroup: 'Theatre Group',
  theatreGroupDeleted: 'Theatre Group Deleted',
  theatreGroupDeletedMessage: '{{groupName}} was deleted',
  theatreGroupDetails: 'Theatre Group Details',
  theatreGroups: 'Theatre Groups',
  theatreName: 'Theatre Name',
  theatres: 'Theatres',
  theatresList: 'Theatres List',
  theatreSmall: 'Theatre',
  theatreTimeZone: 'Theatre Time Zone',
  trackingInfo: 'Tracking Info',
  unarchival_may_take: 'Unarchival may take',
  undo: 'Undo',
  unmappedDevices_one: 'Device (1)',
  unmappedDevices_other: 'Devices ({{count}})',
  untitled: 'Untitled',
  update: 'Update',
  updatedBy: 'Updated By',
  updatedOn: 'Updated On',
  uploadCertificate: 'Upload Certificate',
  uploadDeviceCertificate: 'Upload Device Certificate',
  user: 'User',
  userCount_one: '{{1}} User',
  userCount_other: '{{count}} Users',
  userInviteSent: 'User invite sent successfully',
  userLogs: 'User Logs',
  userRemoved: 'User Removed',
  users: 'Users',
  usersHeaderButtonsInviteUser: 'Invite User',
  usersHeaderButtonsViewLogs: 'View Logs',
  usersHeaderTitle: 'Manage Users',
  validFrom: 'Valid From',
  validNow: 'Valid Now',
  validTo: 'Valid To',
  verificationStatus: 'Verification Status',
  viewAll: 'View All',
  viewAllTheatreGroups: 'View All Theatre Groups',
  viewCreditOffset: 'Credits: {{value}}',
  viewSuiteLogs: 'View Suite Logs',
  viewTheatreGroup: 'View Theatre Group',
  warning: 'Warning',
  wireLinkCopiedToClipboard: 'WireLink copied to clipboard',
  wireLinkCopyFailed: 'Unable to copy, Please try again',
  wireLinkDetails: 'WireLink Details',
  wireLinks: 'WireLinks',
  wiretaps: 'WireTAPs',
  wiretapStatusReport: 'WireTAP Status Report',
  removeDevice: 'Remove Device',
  deleteIpTitle: 'Delete IP Address - {{ip}}',
  appliances: 'Appliances',
  noResultsFor: 'No results for',
  city: 'City',
  province: 'Province',
  country: 'Country',
  confirmAction: 'Confirm Action',
  RequestId: 'Request ID: {{requestId}}',
  moveToUnmapped_name: 'Move to {{name}} Devices',
  language: 'Language',
  subtitleLanguage: 'Subtitle Language',
  mainCaption: 'Main Caption',
  ratings: 'Ratings',
  type: 'Type',
  dciStandard: 'DCI Standard',
  closedSubtitles: 'Closed Subtitles',
  frameRate: 'Frame Rate',
  audioFormats: 'Audio Formats',
  resolution: 'Resolution',
  closedCaptions: 'Closed Captions',
  stereoType: 'Stereo Type',
  aspectRatio: 'Aspect Ratio',
};
